import React from 'react';
import styled from 'styled-components';
import { faClose } from '@fortawesome/pro-light-svg-icons';
import TrueImpactModal from './TrueImpactModal';
import TrueImpactIconButton from './TrueImpactIconButton';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';

const modalAddStyles = `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACERS.medium};
  .modal-wrapper {
    flex: 0 1 auto;
    height: auto;
    max-height: 90vh;
    border-radius: ${SPACERS.tiny};
    box-shadow: 0px 20px 36px rgba(0, 0, 0, 0.25);
  }
  .modal-content {
    background-color: ${COLORS.whiteBase};
    overflow: auto;
    border-radius: ${SPACERS.tiny};
  }
`;

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  .header {
    position: relative;
    padding: ${SPACERS.medium} ${SPACERS.large};
    border-bottom: 1px solid ${COLORS.greyBase};
    .header-content {
      display: flex;
      flex-direction: column;
      gap: ${SPACERS.small};
      padding-right: ${SPACERS.large};
    }
    .header-title {
      margin: ${SPACERS.tiny} 0 0 0;
    }
  }
  .header-close {
    position: absolute;
    top: ${SPACERS.medium};
    right: ${SPACERS.large};
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: ${SPACERS.medium};
    padding: ${SPACERS.large};
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    gap: ${SPACERS.small};
    padding: ${SPACERS.medium} ${SPACERS.large};
    border-top: 1px solid ${COLORS.greyBase};
  }
`;

interface TrueImpactDividerModalProps {
  open: boolean;
  onClose: () => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  maxWidth?: string;
}

const TrueImpactDividerModal: React.FC<TrueImpactDividerModalProps> = ({
  open,
  onClose,
  header,
  footer,
  children,
  maxWidth = '800px',
}) => {
  return (
    <TrueImpactModal
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      hideHeader
      hideFooter
      addStyles={modalAddStyles}
    >
      <StyledDiv>
        {header && (
          <div className="header">
            <div className="header-content">{header}</div>
            <div className="header-close">
              <TrueImpactIconButton
                icon={faClose}
                label="Close"
                color="greyDark"
                onClick={onClose}
              />
            </div>
          </div>
        )}
        <div className="content">{children}</div>
        {footer && <div className="footer">{footer}</div>}
      </StyledDiv>
    </TrueImpactModal>
  );
};

export default TrueImpactDividerModal;
